import React from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Divider from "@material-ui/core/Divider";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import Collapse from "@material-ui/core/Collapse";
import { useHistory } from 'react-router-dom'

function SidebarItem({ depthStep = 10, depth = 0, expanded, item, ...rest }) {
    let history = useHistory();

    const [collapsed, setCollapsed] = React.useState(true);
    const { label, items, Icon, onClick: onClickProp } = item;


    function toggleCollapse() {
        setCollapsed(prevValue => !prevValue);
    }

    function onClick(e) {
        if (item.route) {
            history.push(item.route);
            return;
        }

        if (Array.isArray(items)) {
            toggleCollapse();
        }
        if (onClickProp) {
            onClickProp(e, item);
        }
    }

    let expandIcon;

    if (Array.isArray(items) && items.length) {
        expandIcon = !collapsed ? (
          <ExpandLessIcon className="sidebar-item-expand-arrow sidebar-item-expand-arrow-expanded" />
        ) : (
          <ExpandMoreIcon className="sidebar-item-expand-arrow" />
        );
    }

    return (
        <>
            <ListItem
                className="sidebar-item"
                onClick={onClick}
                button
                dense
                {...rest}
            >
                <div
                    style={{ paddingLeft: depth * depthStep }}
                    className="sidebar-item-content"
                >
                    {Icon && <Icon className="sidebar-item-icon" fontSize="small" />}
                    <div className="sidebar-item-text">{label}</div>
                </div>
                {expandIcon}
            </ListItem>
            <Collapse in={!collapsed} timeout="auto" unmountOnExit>
                {Array.isArray(items) ? (
                    <List disablePadding dense>
                        {items.map((subItem, index) => (
                            <React.Fragment key={`${subItem.name}${index}`}>
                                {subItem === "divider" ? (
                                    <Divider style={{ margin: "6px 0" }} />
                                ) : (
                                        <SidebarItem
                                            depth={depth + 1}
                                            depthStep={depthStep}
                                            item={subItem}
                                        />
                                    )}
                            </React.Fragment>
                        ))}
                    </List>
                ) : null}
            </Collapse>
        </>
    );
}

function Sidebar(props) {

    return (
        <div className="sidebar">
            <div style={{ maxHeight: "100%", overflow: "auto" }}>
                {props.children}
                <List disablePadding dense>
                    {props.items.map((sidebarItem, index) => (
                        <React.Fragment key={`${sidebarItem.name}${index}`}>
                            {sidebarItem === "divider" ? (
                                <Divider style={{ margin: "6px 0" }} />
                            ) : (
                                    <SidebarItem
                                        depthStep={props.depthStep}
                                        depth={props.depth}
                                        expanded={props.expanded}
                                        item={sidebarItem}
                                    />
                                )}
                        </React.Fragment>
                    ))}
                </List>
            </div>
        </div >
    );
}

export default Sidebar;